import { render, staticRenderFns } from "./yesWorkbook.vue?vue&type=template&id=0008665e"
import script from "./yesWorkbook.vue?vue&type=script&lang=js"
export * from "./yesWorkbook.vue?vue&type=script&lang=js"
import style0 from "./yesWorkbook.vue?vue&type=style&index=0&id=0008665e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports